export default __webpack_public_path__ + "static/media/icomoon.5ca54902.svg";